import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { EventForm } from '../forms/EventForm';


export const EventsCreate = (props) => (
    <Create {...props}>
        <SimpleForm 
            submitOnEnter={false} 
            toolbar={<SaveWithCancelToolbar />} 
            redirect='list'
        >
            <EventForm isCreateForm />
        </SimpleForm>
    </Create>
);
